module.exports = __webpack_public_path__ + "static/media/location.62cb0b30.png";